import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import App from "./app";
import AdminPanel from "./pages/admin";
import "./style/app.scss";
import { Provider } from "react-redux";
import store from "./state/store";
import { Toaster } from "sonner";
import { toasterConfig } from "./notify/toast";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <Toaster {...toasterConfig} />
      <Provider store={store}>
        <BrowserRouter>
          <Routes>
            {/* Панель администратора живёт отдельно от экранов теста */}
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="*" element={<App />} />
          </Routes>
        </BrowserRouter>
      </Provider>
  </React.StrictMode>
);
